import React, { useState, useEffect } from "react";
import * as Fa from "react-icons/fa";
import { Calendar } from "primereact/calendar";
import { Link, useSearchParams } from "react-router-dom";
import { InputText } from "primereact/inputtext";
import {
    createAPIEndpointCollateralDestroy,
    EndpointCollateralDestroy,
} from "../../Services/CollateralDestroy/CollateralDestroyService";
import storage from "../../Services/Storage";
import { toast } from "react-toastify";
import { Column } from "primereact/column";
import { DataTable } from "primereact/datatable";
import { AutoComplete } from "primereact/autocomplete";
import Loader from "../../Components/Loader";

const CollateralDestroy = () => {
    const [disable, setDisable] = useState(false);
    const [viewData, setViewData] = useState(false);
    const [selectedProduct, setSelectedProduct] = useState("");
    const [filteredProducts, setFilteredProducts] = useState([]);
    const [products, setProducts] = useState([]);
    const [productsOnview, setProductsOnview] = useState([]);
    const [productDesc, setProductDesc] = useState("");
    const [wareHouse, setWareHouse] = useState("");
    const [adjustmentNum, setAdjustmentNum] = useState("");
    const [loading, setLoading] = useState(false);
    const [currDate, setCurrDate] = useState();
    const [qty, setQty] = useState("");
    const auth = storage.getLocal("user");
    const [addRecordData, setAddRecordData] = useState([]);

    const [searchparam] = useSearchParams();
    let colltId = searchparam.get("stkAdjId");

    const getCollateralDestroyAllData = async () => {
        try {
            const res = await createAPIEndpointCollateralDestroy().get(
                `${EndpointCollateralDestroy.GetColateralDestroyData}?CompId=${auth.CompId}`
            );
            setProducts(res.data.Data);
        } catch (error) {
            console.log("error ", error);
        }
    };

    const handleProductChange = (e) => {
        const selected = e.value;
        setSelectedProduct(selected);
    };

    const searchProduct = (event) => {
        let query = event.query.toLowerCase();
        const filtered = products
            .filter(product =>
                product.DESCRIPTION.toLowerCase().includes(query) ||
                product.CODE.toLowerCase().includes(query)
            )
            .map(product => ({
                ...product,
                displayName: `${product.CODE} - ${product.DESCRIPTION}`
            }));

        setFilteredProducts(filtered);
    };

    const clearGrid = () => {
        setSelectedProduct("");
        setDisable(false);
        setAddRecordData([]);
        setWareHouse("");
        setQty("");
        setProductDesc("");
    };
    const cleardetails = () => {
        setSelectedProduct("");
        setWareHouse("");
        setQty("");
        setProductDesc("");
    };

    const createPayload = () => {
        return {
            userId: auth.UserId,
            compId: auth.CompId,
            strWHId: products[0]?.STK_WH_ID,
            objDetl: addRecordData.map((item) => ({
                stK_ADJ_ITM_SLNO: item.stK_ADJ_ITM_SLNO.toString(),
                masK_STK_TYPE_ID: item.masK_STK_TYPE_ID.toString(),
                stocK_TYPE: item.stocK_TYPE,
                masK_PROD_ID: item.masK_PROD_ID,
                proD_CODE: item.proD_CODE,
                producT_DESCRIPTION: item.producT_DESCRIPTION,
                batcH_NO: item.batcH_NO,
                stocK_QUANTITY: item.stocK_QUANTITY.toString(),
                casE_PACK_STK_QUANTITY: item.casE_PACK_STK_QUANTITY.toString(),
                availablE_STOCK: item.availablE_STOCK.toString(),
                grN_ID: "",
                grnD_ID: "",
                proD_PRICE: item.proD_PRICE.toString(),
                proD_TAX: "0",
            })),
        };
    };

    const updateAddRecordData = () => {
        if (selectedProduct == "") {
            toast.warning("Please Select Product", {
                position: toast.POSITION.TOP_CENTER,
                pauseOnFocusLoss: false,
                closeButton: false,
                autoClose: 2000,
            });
            return;
        }
        const isDuplicate = addRecordData.some(
            (item) => item.masK_PROD_ID === selectedProduct.MASK_PROD_ID
        );

        if (isDuplicate) {
            toast.error("Product is already added", {
                position: toast.POSITION.TOP_CENTER,
                pauseOnFocusLoss: false,
                closeButton: false,
                autoClose: 2000,
            });
            cleardetails();
            return;
        }
        setAddRecordData((prevData) => [
            ...prevData,
            {
                stK_ADJ_ITM_SLNO: prevData.length + 1,
                masK_STK_TYPE_ID: 2,
                stocK_TYPE: "Non-Inventory",
                masK_PROD_ID: selectedProduct.MASK_PROD_ID,
                proD_CODE: selectedProduct.CODE,
                producT_DESCRIPTION: selectedProduct.DESCRIPTION,
                batcH_NO: selectedProduct.PROD_BATCH_NO,
                stocK_QUANTITY: getStkQty(selectedProduct.STOCK_AVAILABLE),
                casE_PACK_STK_QUANTITY: getCaseStkQty(selectedProduct.STOCK_AVAILABLE),
                availablE_STOCK: selectedProduct.STOCK_AVAILABLE,
                grN_ID: "",
                grnD_ID: "",
                proD_PRICE: selectedProduct.MASK_PRICE,
                proD_TAX: "0",
            },
        ]);
        cleardetails();
    };
    const getStkQty = (data) => {
        let item = convertToDecimal(data);
        return item * -1;
    };

    const getCaseStkQty = (data) => {
        let item = Math.round(convertToDecimal(data));
        return item * -1;
    };
    const convertToDecimal = (number) => {
        return Number(number).toFixed(2);
    };

    const saveData = async () => {
        const payload = createPayload();
        if (addRecordData.length == 0) {
            toast.warn("Add item into cart", {
                position: toast.POSITION.TOP_CENTER,
                pauseOnFocusLoss: false,
                closeButton: false,
                autoClose: 2000,
            });
            return;
        }
        // console.log(payload);
        // return;
        setLoading(true); // Start loader
        try {
            const res = await createAPIEndpointCollateralDestroy().post(
                `${EndpointCollateralDestroy.SubmitRecord}`,
                payload
            );
            if (res.data.Status == "Success") {
                toast.success(res.data.Message, {
                    position: toast.POSITION.TOP_CENTER,
                    pauseOnFocusLoss: false,
                    closeButton: false,
                    autoClose: 2000,
                });
            }
            setAdjustmentNum(res.data.StkAdjNo);
            setDisable(true);
        } catch (error) {
            console.log("error ", error);
            toast.error("unable to save Data", {
                position: toast.POSITION.TOP_CENTER,
                pauseOnFocusLoss: false,
                closeButton: false,
                autoClose: 2000,
            });
        }
        finally {
            setLoading(false); // Stop loader after success or failure
        }
    };
    const removeData = (rowData) => {
        setAddRecordData((prevData) => {
            const updatedData = prevData.filter(
                (item) => item.stK_ADJ_ITM_SLNO !== rowData.stK_ADJ_ITM_SLNO
            );
            const adjustedData = updatedData.map((item, index) => ({
                ...item,
                stK_ADJ_ITM_SLNO: index + 1,
            }));

            return adjustedData;
        });
    };

    useEffect(() => {
        setProductDesc(selectedProduct?.DESCRIPTION);
        setWareHouse(selectedProduct?.WH_DESC);
        setQty(selectedProduct?.STOCK_AVAILABLE);
    }, [selectedProduct]);

    useEffect(() => {
        if (colltId) {
            setViewData(true);
            HeaderDataDetails();
            ProductDtaDetls();
        } else {
            let currentDate = new Date();
            setCurrDate(currentDate);
            getCollateralDestroyAllData();
        }
    }, [colltId]);

    const HeaderDataDetails = async () => {
        setLoading(true);
        try {
            const res = await createAPIEndpointCollateralDestroy().get(
                `${EndpointCollateralDestroy.GetStkHeaderData}?strHeaderId=${colltId}&CompId=${auth.CompId}`
            );
            setWareHouse(res.data.Data[0].WAREHOUSE_DESCRIPTION);
            setAdjustmentNum(res.data.Data[0].STK_ADJ_NO);
            setCurrDate(new Date(res.data.Data[0].STOCK_ADJUSTMENT_DATE));
        } catch (error) {
            console.log("error ", error);
        }
        finally{
            setLoading(false);
        }
    };

    const ProductDtaDetls = async () => {
        try {
            const res = await createAPIEndpointCollateralDestroy().get(
                `${EndpointCollateralDestroy.GetSTKDetailsData}?strHeaderId=${colltId}`
            );
            setProductsOnview(res.data.Data);
        } catch (error) {
            console.log("error ", error);
        }
    };
  
    return (
        <>
            <div className="col-12 pt-0 pb-4">
                <div className="row">
                    <div className="col-lg-6 col-md-6 col-sm-12">
                        <nav aria-label="breadcrumb">
                            <ol className="breadcrumb mx-1">
                                <li className="breadcrumb-item">
                                    <Link to="/inventorymanagement/CollateralDestroyAllRecords">
                    Collateral Destroy
                                    </Link>
                                </li>
                                <li className="breadcrumb-item active" aria-current="page">
                  Add
                                </li>
                            </ol>
                        </nav>
                    </div>
                    <div className="col-lg-6 col-md-6 col-sm-12">
                        <div className="float-end mb-2">
                            <Link to="/inventorymanagement/CollateralDestroyAllRecords">
                                <button type="button" className="btn btn-primary">
                                    <Fa.FaLongArrowAltLeft className="backIcon" /> Back to All
                  Records
                                </button>
                            </Link>
                        </div>
                    </div>
                </div>
                <section className="sales-box">
                    <div className="row d-flex justify-content-end align-items-end">
                        <div className="col-lg-4 col-md-4 col-sm-12">
                            <div className="d-block mb-2">
                                <label className="form-label">Adjustment No. </label>
                                <InputText
                                    className="form-control"
                                    value={adjustmentNum}
                                    disabled
                                />
                            </div>
                        </div>
                        <div className="col-lg-4 col-md-4 col-sm-12">
                            <div className="d-block mb-2">
                                <label className="form-label">Date</label>
                                <Calendar value={currDate} dateFormat="dd/mm/yy" disabled />
                            </div>
                        </div>
                        <div className="col-lg-4 col-md-4 col-sm-12">
                            <div className="d-block mb-2">
                                <label className="form-label">Product</label>
                                <AutoComplete
                                    dropdown
                                    value={selectedProduct}
                                    suggestions={filteredProducts}
                                    completeMethod={searchProduct}
                                    field="displayName" // Adjust based on API response structure
                                    onChange={handleProductChange}
                                    placeholder="Select a Product"
                                    disabled={disable || viewData}
                                />
                            </div>
                        </div>
                        <div className="col-lg-4 col-md-4 col-sm-12">
                            <div className="d-block mb-2">
                                <label className="form-label">Warehouse</label>
                                <InputText value={wareHouse} disabled />
                            </div>
                        </div>
                        <div className="col-lg-4 col-md-4 col-sm-12">
                            <div className="d-block mb-2">
                                <label className="form-label">Product Description</label>
                                <InputText
                                    className="form-control"
                                    type="text"
                                    value={productDesc}
                                    placeholder=""
                                    disabled
                                />
                            </div>
                        </div>
                        <div className="col-lg-4 col-md-4 col-sm-12">
                            <div className="d-block mb-2">
                                <label className="form-label">Quantity</label>
                                <InputText
                                    className="form-control"
                                    type="text"
                                    value={qty}
                                    placeholder=""
                                    disabled
                                />
                            </div>
                        </div>
                        {/* {<Loader/>} */}
                        {!viewData&&<div className="col-lg-12 col-md-12 col-sm-12">
                            <div className="text-end mt-3">
                                <button
                                    type="submit"
                                    title="Clear"
                                    className="btn btn-cancel me-3"
                                    onClick={clearGrid}
                                    disabled={disable}
                                >
                  clear
                                </button>
                                <button
                                    type="submit"
                                    title="Add Row"
                                    className="btn btn-outline-primary me-3"
                                    disabled={disable}
                                    onClick={updateAddRecordData}
                                >
                  Add to cart
                                </button>
                                <button
                                    type="submit"
                                    title="Save"
                                    className="btn btn-primary"
                                    onClick={saveData}
                                    disabled={disable}
                                >
                                    {loading ? <Loader/> : "Save"}
                                </button>
                            </div>
                        </div>}
            
                    </div>
                </section>
                {loading ? <Loader /> :
                    <>
                        {addRecordData.length > 0 && (
                            <section className="">
                                <div className="col-lg-12 col-md-12 col-sm-12">
                                    <h3 className="py-2">Records</h3>
                                    <div className="DataTable">
                                        <DataTable
                                            // paginator
                                            rows={10}
                                            value={addRecordData}
                                            // rowsPerPageOptions={[10, 25, 50]}
                                            scrollHeight="80vh"
                                            // showGridlines
                                            scrollable
                                            stripedRows
                                            emptyMessage="No Record found"
                                        >
                                            <Column field="stocK_TYPE" header="Stock Type"></Column>
                                            <Column field="proD_CODE" header="Product Code" />
                                            <Column
                                                field="producT_DESCRIPTION"
                                                header="Product Description"
                                            ></Column>
                                            <Column field="availablE_STOCK" header="Adjusted Stock" />
                                            {!disable && <Column
                                                header="Action"
                                                body={(rowData) => (
                                                    <>
                                                        <i
                                                            className="pi pi-times"
                                                            style={{
                                                                color: "red",
                                                                cursor: "pointer",
                                                                marginLeft: "4px",
                                                            }}
                                                            onClick={() => removeData(rowData)}
                                                        ></i>
                                                    </>
                                                )}
                                            />}
                                        </DataTable>
                                    </div>
                                </div>
                            </section>
                        )}
                        {viewData && <div className="DataTable">
                            <h3 className="py-2">Records</h3>
                            <DataTable
                                rows={10}
                                value={productsOnview}
                                scrollHeight="80vh"
                                // showGridlines
                                scrollable
                                stripedRows
                                emptyMessage="No Record found"
                            >
                                <Column field="STOCK_TYPE" header="Stock Type"></Column>
                                <Column field="PROD_CODE" header="Product Code" />
                                <Column
                                    field="PRODUCT_DESCRIPTION"
                                    header="Product Description"
                                ></Column>
                                <Column field="STOCK_QUANTITY" header="Adjusted Stock" />
                                <Column
                                    header="Action"
                                />
                            </DataTable>
                        </div>}
                    </>
                }
            </div>
        </>
    );
};

export default CollateralDestroy;
